"use strict";
exports.__esModule = true;
exports.RefreshableBreakageProcesses = exports.BreakageProcess = void 0;
var BreakageProcess;
(function (BreakageProcess) {
    // Parent to Custodian Positions
    BreakageProcess["ParentToCustodianPositions"] = "PARENT_TO_CUSTODIAN_POSITIONS";
    // Parent to Custodian Balances
    BreakageProcess["ParentToCustodianBalances"] = "PARENT_TO_CUSTODIAN_BALANCES";
    // Parent to Custodian Fund Activity
    BreakageProcess["ParentToCustodianFundActivity"] = "PARENT_TO_CUSTODIAN_FUND_ACTIVITY";
    // Parent to Custodian Dividends
    BreakageProcess["ParentToCustodianDividends"] = "PARENT_TO_CUSTODIAN_DIVIDENDS";
    // Parent to SubAccount Positions
    BreakageProcess["ParentToSubAccountPositions"] = "PARENT_TO_SUBACCOUNT_POSITIONS";
    // Parent to SubAccount Balances
    BreakageProcess["ParentToSubAccountBalances"] = "PARENT_TO_SUBACCOUNT_BALANCES";
    // added new for SUBs 3462, 3464, 3466, 3468
    BreakageProcess["DebitParentAccountBalances"] = "DEBIT_PARENT_ACCOUNT_BALANCES";
    BreakageProcess["DebitSubAccountBalances"] = "DEBIT_SUB_ACCOUNT_BALANCES";
    BreakageProcess["ShortParentAccountPosition"] = "SHORT_PARENT_ACCOUNT_POSITION";
    BreakageProcess["ShortSubAccountPosition"] = "SHORT_SUB_ACCOUNT_POSITION";
})(BreakageProcess = exports.BreakageProcess || (exports.BreakageProcess = {}));
exports.RefreshableBreakageProcesses = [
    'PARENT_TO_CUSTODIAN_POSITIONS',
    'PARENT_TO_CUSTODIAN_BALANCES',
    'PARENT_TO_SUBACCOUNT_POSITIONS',
    'PARENT_TO_SUBACCOUNT_BALANCES',
    'PARENT_TO_CUSTODIAN_DIVIDENDS',
    'DEBIT_PARENT_ACCOUNT_BALANCES',
    'DEBIT_SUB_ACCOUNT_BALANCES',
    'SHORT_PARENT_ACCOUNT_POSITION',
    'SHORT_SUB_ACCOUNT_POSITION',
];
